import * as api from '../api/depreciationMethods';
import * as pricingTableApi from '../api/pricingTable';
import { createRequestTypes, START, SUCCESS, ERROR } from './global';
import { makeApiActionCreatorV3 } from '@actions/utils';

const prefix = 'APPRAISAL-ADMIN/DEPRECIATION-METHODS';

export const FETCH_ALL_YEARS = createRequestTypes(`${prefix}/FETCH_ALL_YEARS`);

export const fetchAllYears = makeApiActionCreatorV3(
  pricingTableApi.fetchAllYears,
  FETCH_ALL_YEARS[START],
  FETCH_ALL_YEARS[SUCCESS],
  FETCH_ALL_YEARS[ERROR],
);

export const FETCH_PERSONAL_DEPRECIATION_METHODS = createRequestTypes(
  `${prefix}/FETCH_PERSONAL_DEPRECIATION_METHODS`,
);

export const fetchPersonalDepreciationMethods = makeApiActionCreatorV3(
  api.fetchPersonalDepreciationMethods,
  FETCH_PERSONAL_DEPRECIATION_METHODS[START],
  FETCH_PERSONAL_DEPRECIATION_METHODS[SUCCESS],
  FETCH_PERSONAL_DEPRECIATION_METHODS[ERROR],
);

export const INSERT_PERSONAL_DEPRECIATION_METHOD = createRequestTypes(
  `${prefix}/INSERT_PERSONAL_DEPRECIATION_METHOD`,
);

export const insertPersonalDepreciationMethod = makeApiActionCreatorV3(
  api.insertPersonalDepreciationMethod,
  INSERT_PERSONAL_DEPRECIATION_METHOD[START],
  INSERT_PERSONAL_DEPRECIATION_METHOD[SUCCESS],
  INSERT_PERSONAL_DEPRECIATION_METHOD[ERROR],
);

export const FETCH_PERSONAL_DEPRECIATION_METHOD = createRequestTypes(
  `${prefix}/FETCH_PERSONAL_DEPRECIATION_METHOD`,
);

export const fetchPersonalDepreciationMethod = makeApiActionCreatorV3(
  api.fetchPersonalDepreciationMethod,
  FETCH_PERSONAL_DEPRECIATION_METHOD[START],
  FETCH_PERSONAL_DEPRECIATION_METHOD[SUCCESS],
  FETCH_PERSONAL_DEPRECIATION_METHOD[ERROR],
);

export const UPDATE_PERSONAL_DEPRECIATION_METHOD = createRequestTypes(
  `${prefix}/UPDATE_PERSONAL_DEPRECIATION_METHOD`,
);

export const updatePersonalDepreciationMethod = makeApiActionCreatorV3(
  api.updatePersonalDepreciationMethod,
  UPDATE_PERSONAL_DEPRECIATION_METHOD[START],
  UPDATE_PERSONAL_DEPRECIATION_METHOD[SUCCESS],
  UPDATE_PERSONAL_DEPRECIATION_METHOD[ERROR],
);

export const DELETE_PERSONAL_DEPRECIATION_METHOD = createRequestTypes(
  `${prefix}/DELETE_PERSONAL_DEPRECIATION_METHOD`,
);

export const deletePersonalDepreciationMethod = makeApiActionCreatorV3(
  api.deletePersonalDepreciationMethod,
  DELETE_PERSONAL_DEPRECIATION_METHOD[START],
  DELETE_PERSONAL_DEPRECIATION_METHOD[SUCCESS],
  DELETE_PERSONAL_DEPRECIATION_METHOD[ERROR],
);

export const FETCH_DEPRECIATION_SCHEDULES = createRequestTypes(
  `${prefix}/FETCH_DEPRECIATION_SCHEDULES`,
);

export const fetchDepreciationSchedules = makeApiActionCreatorV3(
  api.fetchDepreciationSchedules,
  FETCH_DEPRECIATION_SCHEDULES[START],
  FETCH_DEPRECIATION_SCHEDULES[SUCCESS],
  FETCH_DEPRECIATION_SCHEDULES[ERROR],
);
